<template>
    <Modal :id="'agendamento_crud'" :size="''" :open="show" :FooterDefault="false" :customModalMain="'z-index:100000;'" :customModalBody="'overflow-y: auto !important;'">
        <template v-slot:header>
            <h6 class="modal-title">Novo Agendamento</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" @click="fecharModal()">
                <i class="fas fa-times btn-close-style"></i>
            </button>
        </template>
        <template v-slot:body>
            <Form ref="ABC" @submit="submitForm" class="form-agendamento">
                <div class="row ps-3">
                    <div class="row">
                        <div class="col">
                            <label class="form-label">Consultor</label>
                            <vue-select :options="filtro_consultor" v-model="select_consultor"
                                        :label-by="formatNameConsultor" placeholder="Selecione o Consultor" searchable
                                        search-placeholder="Pesquise" close-on-select clear-on-select :min="1"
                                        class="form-control shadow-v2" :class="{ filled: select_consultor.dsLogin != '' }"
                                        :disabled="isFlag == false">
                            </vue-select>
                            <Field name="dsLoginResponsavel" label="Consultor" type="hidden" rules="required" v-model="Agendamento_Crud.dsLoginResponsavel" />
                            <ErrorMessage name="dsLoginResponsavel" class="form-error" v-show="showErrorMessage" />
                        </div>
                        <div class="col">
                            <label class="form-label">Pessoa</label>
                            <vue-select :options="pessoa_instituicao" v-model="pessoa_instituicao_selects"
                                        :label-by="formatNameUsuarios" placeholder="Selecione a Pessoa" searchable
                                        search-placeholder="Pesquise" close-on-select clear-on-select :min="1"
                                        class="form-control shadow-v2" :class="{ filled: pessoa_instituicao_selects.idPessoa > 0 }">
                            </vue-select>
                            <Field name="idPessoa" label="Pessoa" type="hidden" rules="required" v-model="Agendamento_Crud.idPessoa" />
                            <ErrorMessage name="idPessoa" class="form-error" v-show="showErrorMessage" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="mt-2">
                            <label class="form-label">Tipo</label>
                            <vue-select :options="filtro_tipo" v-model="filtro_tipo_selects" :label-by="formatNameTipo"
                                        placeholder="Selecione o Tipo" searchable search-placeholder="Pesquise" close-on-select
                                        clear-on-select :min="1" class="form-control shadow-v2"
                                        :class="{ filled: filtro_tipo_selects.idTarefaTipo > 0 }">
                            </vue-select>
                            <Field name="idTarefaTipo" label="Tipo" type="hidden" rules="min_value:1"
                                   v-model="Agendamento_Crud.idTarefaTipo" />
                            <ErrorMessage name="idTarefaTipo" class="form-error" v-show="showErrorMessage" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s6 mb-2 mt-2">
                            <label class="form-label">Data</label>
                            <DateInput name="dtTarefa" v-model="Agendamento_Crud.dtTarefa" class="col-12" :isRequired="true"
                                       :customWidth="customWidthDate" dateFormat="DD/MM/YYYY" />
                            <ErrorMessage name="dtTarefa" class="form-error" v-show="showErrorMessage" />
                        </div>
                        <div class="col s6 mb-2 mt-2">
                            <label class="form-label">Hora</label>
                            <Field name="hrTarefa" label="Hora" type="time" class="form-control shadow-v2" rules="required"
                                   v-model="Agendamento_Crud.hrTarefa" :class="{ filled: Agendamento_Crud.hrTarefa }" />
                            <ErrorMessage name="hrTarefa" class="form-error" v-show="showErrorMessage" />
                        </div>
                    </div>
                    <div class="mt-2 mb-2">
                        <input class="form-check-input mr-3" type="checkbox" v-model="Agendamento_Crud.flFixarLembrete"
                               style="margin-right: 8px;">
                        <label class="form-check-label" for="flexCheckDefault">
                            Fixar Lembrete
                        </label>
                    </div>
                    <div class="pe-2 row">
                        <div class="mb-3">
                            <label class="form-label">Observação</label>
                            <textarea class="form-control shadow-v2" v-model="Agendamento_Crud.dsTarefa"
                                      :class="{ filled: Agendamento_Crud.dsTarefa }" rows="5"></textarea>
                            <Field name="dsTarefa" label="Descrição da Justificativa" type="hidden" rules="required"
                                   v-model="Agendamento_Crud.dsTarefa" />
                            <ErrorMessage name="dsTarefa" class="form-error" v-show="showErrorMessage" />
                        </div>
                    </div>
                </div>
            </Form>
        </template>

        <template v-slot:footer>
            <div class="modal-footer">
                <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal" @click="fecharModal()">
                    Fechar
                </button>
                <button type="submit" class="btn btn-red-v2" form="form" v-on:click="submitForm">
                    <svg class="me-2" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" height="16" width="14"
                         viewBox="0 0 448 512">
                        <path d="M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z" />
                    </svg>
                    Salvar Agenda
                </button>
            </div>
        </template>

    </Modal>
</template>

<script>
    import $ from 'jquery'
    import axios from 'axios';
    import VueNextSelect from 'vue-next-select';
    import 'vue-next-select/dist/index.min.css';
    import Modal from '@/components/App/Modal.vue';
    import DateInput from "@/components/App/DateInput.vue";


    export default {
        name: 'ModalAgendamentoCrud',
        components: {
            Modal,
            DateInput,
            'vue-select': VueNextSelect,
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                ocorrencia: {},

                Agendamento_Crud: {
                    idAgendamento: 0,
                    idOcorrencia: 0,
                    idTarefa: 0,
                    flFixarLembrete: false,
                    hrTarefa: '',
                    dtTarefa: '',
                    dsTarefa: '',
                    dsLogin: '',
                    idTarefaTipo: 0,
                },

                pessoa_instituicao: [],
                pessoa_instituicao_selects: { idPessoa: 0 },

                filtro_tipo: [],
                filtro_tipo_selects: [{ idTarefa: 0 }],

                filtro_consultor: [],
                select_consultor: { dsLogin: '' },

                cdSetorClassificacao: 0,
                permissoes: { flAdministrador: 'Não', flGestorNovos: 'Não', flGestorRenovacao: 'Não', flGestorSucessoCliente: 'Não' },

                consultorLogado: [{ dsLogin: '', nmUsuario: '' }],

                showErrorMessage: false,
                customWidthDate: '',
                isFlag: true
            }
        },
        methods: {
            zerarInformacoes() {
                this.Agendamento_Crud = {
                    dsLogin: '',
                    idPessoa: 0,
                    hrTarefa: '',
                    dtTarefa: '',
                    dsTarefa: '',
                };

                this.filtro_tipo_selects = [{ idTarefa: 0 }];
                this.select_consultor = { dsLogin: '' };

                this.showErrorMessage = false;

                this.isFlag = true;
            },
            fecharModal() {
                this.zerarInformacoes();
            },
            formatNameConsultor(consultor) {
                return consultor.nmUsuario;
            },
            formatNameTipo(tipo) {
                return tipo.nmTipo;
            },
            formatNameUsuarios(usuario) {
                return usuario.nmPessoa;
            },
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    $this.getCdSetorClassificacao($this.ocorrencia.idSetorClassificacao);
                })
            },
            getTipoTarefa() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/TipoTarefa/Get', {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.filtro_tipo = response.data.data;
                })
            },
            getPessoa() {
                let $this = this;

                $this.pessoa_instituicao = [];

                if ($this.ocorrencia.idInstituicao > 0) {
                    axios.get(
                        process.env.VUE_APP_ROOT_COMERCIAL_API + "/PessoaInstituicao/GetPessoasInstituicao?idInstituicao=" + $this.ocorrencia.idInstituicao,
                        { headers: $this.$api.getTokenComercial() }
                    ).then((response) => {
                        $this.pessoa_instituicao = response.data.data;
                        $this.getConsultor();
                        setTimeout(() => {
                            if ($this.pessoa_instituicao.length > 0) {
                                $this.pessoa_instituicao_selects = $this.pessoa_instituicao[0];
                            }
                        }, 500);
                    });
                }
                else {
                    axios.get(
                        process.env.VUE_APP_ROOT_COMERCIAL_API + "/Pessoa/GetPessoaById?id=" + $this.ocorrencia.idPessoa,
                        { headers: $this.$api.getTokenComercial() }
                    ).then((response) => {
                        $this.pessoa_instituicao.push(response.data.data);
                        $this.getConsultor();
                        setTimeout(() => {
                            if ($this.pessoa_instituicao.length > 0) {
                                $this.pessoa_instituicao_selects = $this.pessoa_instituicao[0];
                            }
                        }, 500);
                    });
                }
            },
            getDadosUser() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_API_PLATAFORMA + '/Principal/GetDadosUser', {
                    headers: $this.$api.getTokenPlataforma()
                }).then(response => {
                    $this.consultorLogado = [{ dsLogin: response.data.data.dsLogin, nmUsuario: response.data.data.nmUsuario }];
                    $this.getTipoTarefa();
                    $this.getOcorrencia();
                })
            },
            getConsultor() {
                let $this = this;

                if ($this.permissoes.flAdministrador == "Sim" || $this.permissoes.flGestorNovos == "Sim" || $this.permissoes.flGestorRenovacao == "Sim" || $this.permissoes.flGestorSucessoCliente == "Sim") {
                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Equipe/Get?idModulo=' + $this.ocorrencia.idModulo + '&cdSetor=0&cdSetorClassificacao=' + $this.cdSetorClassificacao, {
                        headers: $this.$api.getTokenComercial(),
                        params: ''
                    }).then(response => {
                        $this.filtro_consultor = response.data.data;
                        $this.isFlag = true;
                        setTimeout(() => {
                            $this.Agendamento_Crud.dsLoginResponsavel = $this.consultorLogado[0].dsLogin;
                            if ($this.filtro_consultor.some(e => e.dsLogin === $this.Agendamento_Crud.dsLoginResponsavel)) {
                                $this.select_consultor = $this.filtro_consultor.find(e => e.dsLogin === $this.Agendamento_Crud.dsLoginResponsavel);
                            }
                        }, 500);
                    })
                }
                else {
                    $this.filtro_consultor = $this.consultorLogado;
                    $this.isFlag = false;
                    setTimeout(() => {
                        $this.Agendamento_Crud.dsLoginResponsavel = $this.filtro_consultor[0].dsLogin;
                        if ($this.Agendamento_Crud?.dsLoginResponsavel && Array.isArray($this.filtro_consultor)) {
                            $this.select_consultor = $this.filtro_consultor.find(e => e.dsLogin === $this.Agendamento_Crud.dsLoginResponsavel) || null;
                        }
                    }, 500);
                }
            },
            getPermissoesUsuario() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Equipe/GetPermissoesUsuarioModulo?idModulo=' + $this.ocorrencia.idModulo, {
                    headers: $this.$api.getTokenComercial()
                }).then(response => {
                    $this.permissoes = response.data.data;
                    $this.getPessoa();
                })
            },
            getCdSetorClassificacao(idSetorClassificacao) {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/SetorClassificacao/GetCdSetorClassificacao?idSetorClassificacao=' + idSetorClassificacao, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.cdSetorClassificacao = response.data.data;
                    $this.getPermissoesUsuario();
                })
            },
            submitForm() {
                let $this = this;

                $this.$refs.ABC.validate()
                    .then(isValid => {
                        if (isValid.valid) {
                            $this.Agendamento_Crud.idOcorrencia = $this.ocorrencia.idOcorrencia;

                            axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Agendamento/PostAgendamentoOcorrencia', $this.Agendamento_Crud, { headers: $this.$api.getTokenComercial() })
                                .then(function (response) {
                                    var myModalEl = document.getElementById('agendamento_crud');
                                    var ModalNewAgendamento = window.bootstrap.Modal.getInstance(myModalEl);

                                    ModalNewAgendamento.hide();

                                    $this.$emit('reloadGrid');
                                    $this.zerarInformacoes()
                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }

                                    $this.$toast.show('alert', msg, true);
                                });
                            $this.showErrorMessage = false;
                        } else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatorios';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
            },
        },
        mounted() {
        },
        watch: {
            show(n, o) {
                if (n) {
                    this.getDadosUser();
                }
            },
            filtro_tipo_selects(new_Tipo_Selected, old_Tipo_Selected) {
                this.Agendamento_Crud.idTarefaTipo = new_Tipo_Selected.idTarefaTipo;
            },
            select_consultor(new_Usuarios_Selected, old_Usuarios_Selected) {
                this.Agendamento_Crud.dsLoginResponsavel = new_Usuarios_Selected.dsLogin;
            },
            pessoa_instituicao_selects(newVal, oldVal) {
                this.Agendamento_Crud.idPessoa = newVal.idPessoa;
            },
            idOcorrencia(newVal, oldVal) {
                /*this.getOcorrencia(newVal);*/
            },
        }
    }

</script>

<style scoped>
    .fundo-dados {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
</style>